import * as React from "react";
import usePluginEntities from "hooks/usePluginEntities";
const PageContextProviders = ({ children }) => {
  const contextProviders = usePluginEntities("pageContextProviders");
  if (!contextProviders || (contextProviders == null ? void 0 : contextProviders.length) === 0) {
    return children;
  }
  return contextProviders.reduce(
    (nestedChildren, PageContextProvider) => /* @__PURE__ */ React.createElement(PageContextProvider, null, nestedChildren),
    children
  );
};
export default PageContextProviders;
